module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_foilRosegoldHover-d8b1d98b1a70e0725cc7092c7503ee75.jpg";